<template>
  <div v-if="loaded" class="row">
  <!-- Réorganise ton formulaire ici -->
        <mh-input mhClass="col-6" field="nom" :table="seller"></mh-input>
    <mh-input mhClass="col-6" field="prenom" :table="seller"></mh-input>
    <mh-input mhClass="col-6" field="langue" :table="seller"></mh-input>
    <mh-input mhClass="col-6" field="commission" :table="seller" append="%"></mh-input>
    
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import sellers from "@/services/sellers";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Seller",
  components: {
    MhInput,
  },
  props: {
    seller_id: [Number, String],
  },
  data() {
    return {
      seller: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      sellers
        .seller({
          seller_id: this.seller_id,
        })
        .then((response) => {
          this.seller = response.data;
          this.loaded = true;
        });
    },
    
    save() {
      sellers.update_seller({
        seller_id: this.seller_id,
        seller: this.seller
      }).then(response => {
        if (response.data.success) {
          this.$bvToast.toast("seller mise à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
          for (let el in this.seller) {
            if (this.seller[el]) {
              this.seller[el].error = false;
            }
          }
          this.$emit('change');
          this.$emit('close');
        } else if (response.data.fail) {
          for (let el in this.seller) {
            if (this.seller[el]) {
              this.seller[el].error = false;
            }
          }
          response.data.fail.forEach((element) => {
            this.seller[element.field].error = element.errors.join(" ; ");
          });
        } else if (response.data.error) {
          this.$bvToast.toast("Erreur : " + response.data.error, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>